import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ConversationMetadata } from "@stratify/shared";

export interface DocumentAgentConversation {
  id: string;
  metadata: ConversationMetadata;
}

export interface DocumentAgentConversationsState {
  conversationsByDocId: {
    [documentId: string]: DocumentAgentConversation[];
  };
  loadingStates: {
    [documentId: string]: "idle" | "loading" | "succeeded" | "failed";
  };
  errorMessages: {
    [documentId: string]: string | null;
  };
}

const initialState: DocumentAgentConversationsState = {
  conversationsByDocId: {},
  loadingStates: {},
  errorMessages: {},
};

const documentAgentConversationsSlice = createSlice({
  name: "documentAgentConversations",
  initialState,
  reducers: {
    setConversationsLoading: (
      state,
      action: PayloadAction<{ documentId: string }>
    ) => {
      const { documentId } = action.payload;
      state.loadingStates[documentId] = "loading";
      state.errorMessages[documentId] = null;
    },
    setConversationsSuccess: (
      state,
      action: PayloadAction<{
        documentId: string;
        conversations: DocumentAgentConversation[];
      }>
    ) => {
      const { documentId, conversations } = action.payload;
      state.conversationsByDocId[documentId] = conversations;
      state.loadingStates[documentId] = "succeeded";
      state.errorMessages[documentId] = null;
    },
    setConversationsError: (
      state,
      action: PayloadAction<{ documentId: string; error: string }>
    ) => {
      const { documentId, error } = action.payload;
      state.loadingStates[documentId] = "failed";
      state.errorMessages[documentId] = error;
    },
  },
});

// Actions
export const {
  setConversationsLoading,
  setConversationsSuccess,
  setConversationsError,
} = documentAgentConversationsSlice.actions;

export default documentAgentConversationsSlice.reducer;
